<template>
   <div>
      <template v-if="!isForeign">
         <big-title>
            Abonar Fondos
         </big-title>
         <pay-funds-national />
      </template>
      <template v-else>
         <big-title>
            Abonar <span>fondos</span>.
         </big-title>
         <pay-funds-foreign />
      </template>
   </div>
</template>

<script>
import PayFundsNational from "@views/investor/funds/PayFundsNational";
import PayFundsForeign from "@views/investor/funds/PayFundsForeign";
import investorInfoHelper from "@/helpers/investorInfoHelper";

export default {
   components: { PayFundsNational, PayFundsForeign },
   mixins: [investorInfoHelper],
   data() {
      return {
         isForeign: false,
      }
   },
   async beforeMount() {
      this.isForeign = this.userIsForeign(this.UserPersonType);
   },
}
</script>
